"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _color = _interopRequireDefault(require("color"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _providers = require("../../toolkit/providers");

var _styling = require("../../toolkit/styling");

/* Lego Toolkit */
var demoProps = {
  onDelete: function onDelete() {}
};
var propDoc = {
  onDelete: {
    required: false,
    type: "undefined | ((() => void))",
    description: "If the token can be deleted, a function to be called when the delete (\"x\") button is clicked" + ". If this prop is not provided, token will not render a delete button."
  }
};

var Token = function Token(props) {
  var className = props.className,
      style = props.style,
      children = props.children,
      onDelete = props.onDelete;
  var styles = useStylesheet();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.text)
  }, children), onDelete && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "closeIcon",
    className: (0, _styling.css)(styles.iconContainer, styles.icon),
    onClick: onDelete
  }));
};

Token.propDoc = propDoc;
Token.demoProps = demoProps;
var _default = Token;
exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _useTheming = (0, _providers.useTheming)(),
      fonts = _useTheming.fonts,
      primary = _useTheming.theme.primary;

  var backgroundColor = new _color["default"](primary).alpha(0.2).toString();
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: backgroundColor,
        padding: 5,
        borderRadius: 3,
        cursor: "default",
        flexShrink: 0,
        justifyContent: "space-between",
        fontFamily: fonts.regular
      },
      iconContainer: {
        flexShrink: 0,
        display: "flex",
        height: 14,
        width: 14
      },
      icon: {
        height: 14,
        marginLeft: 5,
        cursor: "pointer",
        flexShrink: 0
      },
      text: {
        fontSize: 13,
        flexShrink: 0,
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden"
      }
    });
  }, [backgroundColor, fonts.regular]);
};